import Nav from "./Nav";

const Header = () => {
    return (
        <header className="container bg-libraryHeader bg-cover h-[600px]">
            <section className="flex justify-between items-center container px-7 py-3 bg-sky-800 text-slate-50 rounded-b-3xl  shadow-3xl fixed top-0 z-20">
                <Nav />

                <figure className="flex flex-col items-center">
                    <img className="w-10 " src={require(`../../assets/images/logo.png`)} alt="" />
                    <figcaption className="text-xs">دانشگاه تخصصی فناوری های نوین آمل</figcaption>
                </figure>
            </section>
            <section className="w-[500px]  text-slate-50 text-xl font-bold  py-2 px-3 flex flex-wrap gap-x-5 relative top-[60%] right-10">
                <a href="/" className="block py-3 px-6 bg-gradient-to-t from-indigo-600 to-indigo-900 rounded-t-3xl">
                    ورود اعضا
                </a>
                <a href="/" className="block py-3 px-6 bg-gradient-to-t from-indigo-600 to-indigo-900 rounded-t-3xl">
                    جستجو در کتابخانه
                </a>
                <h1 className="bg-[rgba(0,0,0,0.4)] py-6 px-1">کتاب خانه مرکزی دانشگاه تخصصی فناوری های نوین آمل</h1>
            </section>
        </header>
    );
};

export default Header;
